import React from 'react'
import PropTypes from 'prop-types'
import * as Component from './Link.styles'

/**
 * Generic Link Component
 */
const Link = (props) => {
  const {
    id,
    children,
    href,
    className,
    iconClass,
    iconIsRight,
    isNativeLink,
    to,
    ...other
  } = props

  const isPhone = href && href.match(/^tel:/)
  const LinkComponent = isNativeLink
    ? Component.NativeLink
    : Component.ReactLink

  let telWithSpaces = ''
  if (isNativeLink && isPhone) {
    const numbers = href.slice(4, href.length)

    for (let i = 0; i < numbers.length; i = i + 1) {
      telWithSpaces += `${ numbers.charAt(i) } `
    }
  }

  return (
    <LinkComponent
      id={ id }
      className={ className }
      to={ to }
      href={ href }
      { ...(isPhone && { 'aria-label': telWithSpaces }) }
      { ...other }>
      {iconClass && !iconIsRight && (
        <Component.LinkIcon className={ iconClass } position='left' />
      )}
      {children}
      {iconClass && iconIsRight && (
        <Component.LinkIcon className={ iconClass } position='right' />
      )}
    </LinkComponent>
  )
}

Link.defaultProps = {
  disabled: false,
  iconIsRight: false,
  isNativeLink: false,
  to: '',
}

Link.propTypes = {
  /** Unique css identifier */
  id: PropTypes.string,
  /** The element content */
  children: PropTypes.node,
  /** The link's destination - only required if link is native link*/
  href(props, propName) {
    if (
      props.isNativeLink &&
      (props[propName] === undefined || typeof props[propName] !== 'string')
    ) {
      return new Error('"href" Prop must be specified')
    }
  },
  /** The icon class */
  iconClass: PropTypes.string,
  /** specifies position of icon relative to link text */
  iconIsRight: PropTypes.bool,
  /** Specifies if link is native a link or react link */
  isNativeLink: PropTypes.bool,
  /** Specifies the route target - only required if link is react link */
  // to (props, propName) {
  //   if (!props.isNativeLink && (props[propName] === undefined || typeof props[propName] !== 'string')) {
  //     return new Error('"To" Prop must be specified')
  //   }
  // },
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      to: PropTypes.string,
      state: PropTypes.object,
    }),
  ]),
  className: PropTypes.string,
}

export default Link
